import { render, staticRenderFns } from "./mainBanner.vue?vue&type=template&id=4982f63a&scoped=true"
import script from "./mainBanner.vue?vue&type=script&lang=js"
export * from "./mainBanner.vue?vue&type=script&lang=js"
import style0 from "./mainBanner.vue?vue&type=style&index=0&id=4982f63a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4982f63a",
  null
  
)

export default component.exports